<header class="navbar navbar-expand-lg navbar-dark fixed-top nga-navbar">
    <nav class="container" aria-label="Main navigation">
  <a class="mindlogo" routerLink="/"> 
      <img height="90px;" src="assets/svg/clarichat.svg" alt="ClariChat">
  </a>
      <button 
        class="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a class="nav-link nga-nav-link" [routerLink]="['/iq/lab']">
       
                <img src="assets/svg/flask.svg" height="40px" class="menusvg" />&nbsp;
             IQ Footprint
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nga-nav-link" [routerLink]="['/iq/lab']">
       
                <img src="assets/svg/red-person.svg" height="33px" class="menusvg" />&nbsp;
            Personality
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nga-nav-link" [routerLink]="['/iq/ryhme']">
                <img src="assets/svg/duck.svg" height="37px" class="menusvg" />&nbsp;
             Witty Duck 
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nga-nav-link" [routerLink]="['/iq/read']">
                <img src="assets/svg/read-kid.svg" height="40px" class="menusvg" /> &nbsp;
           Reading Room
            </a>
          </li>
        </ul>  
      </div>
    </nav>
  </header>
  

  <div class="row no-gutters signin-page" style="background-color: black;">
    <div class="container py-5">
      <div class="chat-container">
        <!-- Messages area -->
        <div class="messages-container" #messagesContainer>
          <div *ngFor="let message of currentMessages" class="message" [ngClass]="{'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant'}">
            <div [innerHTML]="convertMarkdown(message.content)"></div>
            <div class="message-timestamp">{{message.timestamp | date:'short'}}</div>
          </div>
  
          <!-- Pacman Loading Animation -->
          <div *ngIf="isLoading" class="pacman-loader">
            <div class="pacman"></div>
            <div class="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
  
        <!-- Input area -->
        <div class="input-container">
          <textarea [(ngModel)]="userInput" placeholder="Ask me anything..." (keydown)="onKeyDown($event)"></textarea>
          <button class="btn-chat-bigal" (click)="sendMessage()" [disabled]="isLoading || !userInput.trim()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>